import { render, staticRenderFns } from "./ChartPay.vue?vue&type=template&id=b0fa7e32&scoped=true&"
import script from "./ChartPay.vue?vue&type=script&lang=js&"
export * from "./ChartPay.vue?vue&type=script&lang=js&"
import style0 from "./ChartPay.vue?vue&type=style&index=0&id=b0fa7e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fa7e32",
  null
  
)

export default component.exports